import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { benchmarkScore } from './types';

import { requestPostBenchmarkDataSuccess, requestPostBenchmarkDataFailure } from './reducer';

const logger = new Logger('Saga:Monitor');

export function* requestPostBenchmarkData(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.monitor.business-score'),
      action.payload,
    );

    yield put(requestPostBenchmarkDataSuccess(response.data.score));
  } catch (error) {
    logger.info('Failed to post benchmark data', error);
    yield put(requestPostBenchmarkDataFailure(error));
  }
}

export default function* benchmarkSaga() {
  return yield all([takeLatest(benchmarkScore.request, requestPostBenchmarkData)]);
}
